import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AuditPageEntries } from "../../member/chase-detail/chase-detail-chart/audit-page-entry/audit-page-entries.model";
import { AuditPackage } from "../models/audit-package.model";

@Injectable({
  providedIn: "root",
})
export class AuditDataSharingService {
  private auditPackagesSubject = new BehaviorSubject<AuditPackage[]>([]);
  private pageEntriesSubject = new BehaviorSubject<Map<number, AuditPageEntries[]>>(new Map());

  setAuditPackages(auditPackages: AuditPackage[]): void {
    this.auditPackagesSubject.next(auditPackages);
  }

  getAuditPackages(): AuditPackage[] {
    return this.auditPackagesSubject.value;
  }

  getAuditPackagesObservable() {
    return this.auditPackagesSubject.asObservable();
  }

  setPageEntries(auditPackageId: number, pageEntries: AuditPageEntries[]): void {
    const currentMap = this.pageEntriesSubject.value;
    currentMap.set(auditPackageId, pageEntries);
    this.pageEntriesSubject.next(new Map(currentMap));
  }

  getPageEntries(auditPackageId: number): AuditPageEntries[] {
    return this.pageEntriesSubject.value.get(auditPackageId) || [];
  }

  getPageEntriesObservable() {
    return this.pageEntriesSubject.asObservable();
  }

  clearAllData(): void {
    this.auditPackagesSubject.next([]);
    this.pageEntriesSubject.next(new Map());
  }

  getActiveAuditPackageId(): number | null {
    const auditPackages = this.getAuditPackages();
    if (auditPackages && auditPackages.length > 0) {
      return auditPackages[0].auditPackageID;
    }
    return null;
  }
}
